export enum StepsType {
  Default = 'default',
  Navigation = 'navigation'
}